<template>
  <div :class="['home__main-content', displayLayout]">
    <client-only>
      <section
        class="home__swiper-container"
        :class="bannerList.length === 0 ? 'empty' : ''"
      >
        <SwiperBanner @click="jumpProductDetail" :bannerList="bannerList" />
      </section>
    </client-only>
    <section class="home__featured-content" :class="displayLayout">
      <template v-if="isMobile">
        <p v-if="gameList.length === 0" class="title">
          {{ $t('common.hot_selection') }}
        </p>
        <p v-else class="title">
          <span
            v-for="(item, index) in dataSource"
            :key="item.key"
            @click="onSwitchList(index)"
            v-show="item.data.length > 0"
            :class="activeIndex === index ? 'active' : ''"
            >{{ item.title }}</span
          >
        </p>
        <Banner2
          v-for="(item, index) in dataSource"
          :key="item.key"
          :type="item.key"
          @click="jumpProductDetail"
          v-show="activeIndex === index"
          :gameList="item.data"
          :listIsLoading="listIsLoading"
          :activeIndex="activeIndex"
        />
      </template>
      <template v-if="isDesktop">
        <p class="title" v-show="listIsLoading">
          {{ $t('common.hot_selection') }}
        </p>
        <div v-for="(item, index) in dataSource" :key="item.key">
          <p class="title" v-show="!listIsLoading && item.data?.length > 0">
            {{ item.title }}
          </p>
          <Banner2
            :type="item.key"
            @click="jumpProductDetail"
            :gameList="item.data"
            :listIsLoading="listIsLoading"
            v-show="(listIsLoading && index === 0) || item.data?.length > 0"
          />
        </div>
      </template>
    </section>
  </div>
</template>
<script>
  import SwiperBanner from './component/swiper/index2'
  import Banner2 from './component/Banner/index2'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'home2',
    components: {
      SwiperBanner,
      Banner2,
    },
    props: {
      listIsLoading: { type: Boolean, default: true },
      bannerList: { type: Array, default: () => [] },
      gameList: { type: Array, default: () => [] },
    },
    data() {
      return {
        codeGameList: [],
        directGameList: [],
        activeIndex: 0, // 当前选择标题索引， 直充：0，点卡：1
      }
    },
    computed: {
      ...mapState(['isMobile', 'isDesktop']),
      ...mapGetters(['displayLayout']),
      dataSource() {
        return [
          {
            key: 'direct',
            title: this.$t('common.direct_topup'), //'直充',
            data: this.directGameList,
          },
          {
            key: 'code',
            title: this.$t('common.code_card'), //'点卡',
            data: this.codeGameList,
          },
        ]
      },
    },
    watch: {
      gameList(val) {
        if (val && val.length > 0) {
          this.init()
        }
      },
    },
    methods: {
      jumpProductDetail(item) {
        this.$emit('jumpProductDetail', item)
      },
      init() {
        this.codeGameList = []
        this.directGameList = []
        this.gameList.forEach((obj) => {
          if (obj.displayArea === 2) {
            // 点卡类型
            this.codeGameList.push(obj)
          } else {
            // 直充类型 displayArea === 1
            this.directGameList.push(obj)
          }
        })
        if (this.directGameList.length === 0 && this.codeGameList.length > 0) {
          this.activeIndex = 1
        }
      },
      onSwitchList(type) {
        this.activeIndex = type
      },
    },
  }
</script>

<style scoped lang="scss">
  .home-page-container {
    .home__featured-content {
      padding: 0 45px;
      box-sizing: border-box;
      margin: 0 auto;
      .title {
        font: 600 48px/65px 'Roboto';
        margin-bottom: 45px;
        & > span {
          margin-right: 68px;
          position: relative;
          z-index: 1;
          display: inline-block;
          height: 50px;
          &.active::after {
            content: '';
            z-index: -1;
            position: absolute;
            left: -10px;
            bottom: 2px;
            width: 230px;
            height: 18px;
            background: linear-gradient(
              89.99deg,
              #ff910f 1.92%,
              rgba(255, 69, 11, 0) 99.99%
            );
            opacity: 0.9;
            border-radius: 30px 0 0 30px;
          }
        }
      }
    }
    &.version-2 {
      .home__featured-content .title {
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        & > span.active {
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .home__main-content.desktop-layout {
    min-width: min(100%, 680px);
    .home__swiper-container {
      width: 100%;
      background-image: url('~@/assets/images/home/swiper-bg__PC.png'),
        linear-gradient(359.4deg, #1d1d27 0.51%, rgba(29, 29, 39, 0.6) 99.47%);
      background-clip: border-box;
      background-size: 100%;
      background-repeat: no-repeat;
      padding-bottom: 64px;
      padding-top: 70px; // 注：与 header 的高度保持一致
      margin-top: -68px;
      // 下方代码是为了在没有轮播图（display:none）的情况下仍然显示背景图
      &.empty {
        background-position: bottom;
        &::after {
          content: '';
          z-index: 0;
          position: absolute;
          top: -54px;
          width: 100%;
          height: 441px;
          background-image: url('~@/assets/images/home/swiper-bg__PC.png'),
            linear-gradient(
              359.4deg,
              #1d1d27 0.51%,
              rgba(29, 29, 39, 0.6) 99.47%
            );
          background-clip: border-box;
          background-size: 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .home__featured-content {
      width: auto;
      margin-top: -46.38px;
      padding: 0;
      /**********************/
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        /** 以下代码是为了保证标题与游戏列表左端对齐 */
        width: 100%;
        max-width: min(1080px, 91.66vw);
        min-width: 620px;
        margin: 0 auto;
        /**********************/
        font-family: 'Roboto-Medium';
        font-style: italic;
        font-weight: 700;
        font-size: 30px;
        line-height: 30px;
        background-image: linear-gradient(
          180deg,
          #ffffff 13.64%,
          rgba(255, 255, 255, 0) 115.91%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        margin-bottom: 20px;

        position: relative;
        z-index: 1; // 确保不会被 .home__swiper-container.empty 的 after 伪元素压住
        &::before {
          content: '';
          display: inline-block;
          height: 23px;
          width: 8px;
          margin-right: 4.64px;
          background-position: left bottom;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url('~@/assets/images/home/title__vertical-dot.png');
          transform: skewX(-7deg);
        }
      }
    }
  }
</style>
